module.exports = __webpack_public_path__ + "static/img/face_img.c12c54e9.png";